/* styled-components & other non-external style-related exports (like, say, a `headerHeight` var) go here */
import { colors, font, ChevronIcon, spacing } from '@chegg-ui/theme';
import styled, { css } from 'styled-components';
var underlineStyling = css(["&:link,&:visited{text-decoration:none;}&:focus,&:hover,&:active{text-decoration:underline;}"]);
export var PrimaryStyledLink = styled.a.withConfig({
  componentId: "sc-1ecizwc-0"
})(["text-decoration:none;align-items:center;display:inline-flex;", " font-family:", ";font-size:", ";font-weight:", ";line-height:", ";", ""], underlineStyling, font.family["default"], function (_ref) {
  var size = _ref.size;
  return size === 'large' ? font.size.px20 : font.size.px16;
}, font.weight.bold, function (_ref2) {
  var size = _ref2.size;
  return size === 'large' ? font.lineHeight.sm : font.lineHeight.xs;
}, function (_ref3) {
  var adjustToBackgroundColor = _ref3.adjustToBackgroundColor;

  switch (adjustToBackgroundColor) {
    case 'dark':
      {
        return "\n        color: ".concat(colors.white, ";\n        :visited {\n          color: ").concat(colors.white, ";\n        }\n      ");
      }

    case 'light':
      {
        return "\n        color: ".concat(colors.dark, ";\n        :visited {\n          color: ").concat(colors.dark, ";\n        }\n      ");
      }

    case undefined:
    default:
      {
        return "\n        color: ".concat(colors.link, ";\n        :visited {\n          color: ").concat(colors.royal, ";\n        }\n      ");
      }
  }
});
export var SecondaryStyledLink = styled.a.withConfig({
  componentId: "sc-1ecizwc-1"
})(["&:link,&:visited,&:focus,&:hover,&:active{color:", ";}", " align-items:center;display:inline-flex;font-family:", ";font-size:", ";font-weight:", ";line-height:", ";"], colors.dark, underlineStyling, font.family["default"], font.size.px14, font.weight.medium, font.lineHeight.xs);
export var RepositionedChevron = styled(ChevronIcon).withConfig({
  componentId: "sc-1ecizwc-2"
})(["", "}position:relative;margin-left:", ";"], function (_ref4) {
  var pointing = _ref4.pointing;

  switch (pointing) {
    case 'up':
      return "top: -0.125rem;";

    case 'left':
      return "top: -0.075rem;";

    case 'down':
      return "top: 0;";

    case 'right':
    default:
      return "top: -0.075rem;";
  }
}, spacing.px4);
export var ChevronStyledLink = styled.a.withConfig({
  componentId: "sc-1ecizwc-3"
})([""]);
var seoLinkStyles = "\nfont-family: ".concat(font.family["default"], ";\n  color: ").concat(colors.dark, ";\n  :visited {\n    color: ").concat(colors.dark, ";\n  }\n"); // "SEO" Link definitions follow:

export var SEOEyebrowLink = styled.a.withConfig({
  componentId: "sc-1ecizwc-4"
})(["", " ", " font-size:", ";font-weight:", ";line-height:", ";"], seoLinkStyles, underlineStyling, font.size.px20, font.weight.heavy, font.lineHeight.xs);
export var SEOSubjectLink = styled.a.withConfig({
  componentId: "sc-1ecizwc-5"
})(["", " ", " font-size:", ";font-weight:", ";line-height:", ";"], seoLinkStyles, underlineStyling, font.size.px16, font.weight.bold, font.lineHeight.sm);
export var SEOSubSubjectLink = styled.a.withConfig({
  componentId: "sc-1ecizwc-6"
})(["", " ", " font-size:", ";font-weight:", ";line-height:", ";"], seoLinkStyles, underlineStyling, font.size.px16, font.weight.normal, font.lineHeight.sm);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/link/dist/esm/styles.js
// module id = 620
// module chunks = 11